import { render, staticRenderFns } from "./PhonebookDepartment.vue?vue&type=template&id=6990ab81&"
import script from "./PhonebookDepartment.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PhonebookDepartment.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6990ab81')) {
      api.createRecord('6990ab81', component.options)
    } else {
      api.reload('6990ab81', component.options)
    }
    module.hot.accept("./PhonebookDepartment.vue?vue&type=template&id=6990ab81&", function () {
      api.rerender('6990ab81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPhonebook/components/PhonebookDepartment.vue"
export default component.exports